module.exports = __webpack_public_path__ + "img/share-bg-11.94fafa39.jpg";